const PHONE_FIELDS = [
  'phone',
  'contact',
  'contactNumber',
  'phoneNumber',
  'mobile',
  'mobileNumber',
  'phoneDisplay',
] as const;

export const resolveBookingPhone = (booking: Record<string, unknown>): string => {
  for (const field of PHONE_FIELDS) {
    const value = booking[field];

    if (typeof value === 'number' && Number.isFinite(value)) {
      return String(value);
    }

    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return '';
};
